<template>
    <svg
        width="100"
        height="31"
        viewBox="0 0 100 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            y="0.5"
            width="100"
            height="30"
            rx="15"
            fill="black"
            fill-opacity="0.2"
        />
        <g clip-path="url(#clip0_3399_2912)">
            <g clip-path="url(#clip1_3399_2912)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.0009 8.9311C23.7088 8.8798 24.9485 8.54617 26.6747 7.57026C26.7483 7.52865 26.8405 7.53682 26.9048 7.59167L29.8522 10.1051C29.9349 10.1756 29.9448 10.3008 29.8768 10.3855C28.9336 11.5591 28.2864 12.5321 27.8993 13.4208L25.1783 10.6569C25.1426 10.6206 25.0938 10.6002 25.0429 10.6002H16.959C16.9081 10.6002 16.8593 10.6206 16.8236 10.6569L14.1025 13.4209C13.7155 12.5322 13.0682 11.5591 12.1251 10.3855C12.057 10.3008 12.0669 10.1756 12.1496 10.1051L15.097 7.59167C15.1614 7.53682 15.2536 7.52865 15.3272 7.57026C17.0533 8.54617 18.293 8.8798 21.0009 8.9311ZM14.4496 14.4777C14.6964 15.6276 14.4821 16.7081 13.8988 18.0181C13.8603 18.1045 13.8857 18.2072 13.9615 18.2636L20.8815 23.4114C20.9524 23.4641 21.0494 23.4641 21.1203 23.4114L28.0403 18.2636C28.1162 18.2072 28.1415 18.1045 28.1031 18.0181C27.5198 16.7082 27.3055 15.6277 27.5522 14.4779L21.1443 21.8357C21.0685 21.9226 20.9334 21.9226 20.8577 21.8357L14.4496 14.4777Z"
                    fill="url(#paint0_linear_3399_2912)"
                />
                <g filter="url(#filter0_d_3399_2912)">
                    <path
                        d="M25 14.3017L23.2889 12.7002H18.7111L17 14.3017L21 18.5336L25 14.3017Z"
                        fill="white"
                    />
                </g>
            </g>
        </g>
        <path
            d="M46.284 19H39.48V10.96H46.284V12.58H41.28V14.152H46.104V15.76H41.28V17.38H46.284V19ZM48.9092 19H46.5572L49.6892 15.028V14.896L46.5572 10.96H48.9092L51.1652 13.828H51.2972L53.4692 10.96H55.8212L52.7012 14.932V15.064L55.8212 19H53.4692L51.2252 16.096H51.0932L48.9092 19ZM58.0378 19H56.2378V10.96H60.4378C62.2978 10.96 63.4978 12.016 63.4978 13.864C63.4978 15.712 62.2978 16.78 60.4378 16.78H58.0378V19ZM60.2458 12.58H58.0378V15.16H60.2458C61.2418 15.16 61.7098 14.872 61.7098 13.864C61.7098 12.88 61.2418 12.58 60.2458 12.58ZM70.9403 19H64.1363V10.96H70.9403V12.58H65.9363V14.152H70.7603V15.76H65.9363V17.38H70.9403V19ZM73.5534 19H71.7534V10.96H76.1934C78.1734 10.96 79.3014 11.836 79.3014 13.372C79.3014 14.68 78.5454 15.46 77.0334 15.604V15.7C77.7534 15.892 78.0294 16.276 78.3294 16.84L79.4934 19H77.4054L76.3014 16.912C75.9774 16.288 75.6774 16.084 74.7414 16.084H73.5534V19ZM73.5534 12.58V14.728H76.1814C77.0334 14.728 77.4174 14.488 77.4174 13.648C77.4174 12.856 77.0334 12.58 76.1814 12.58H73.5534ZM84.538 19H82.738V12.58H79.75V10.96H87.526V12.58H84.538V19Z"
            fill="white"
        />
        <defs>
            <filter
                id="filter0_d_3399_2912"
                x="10.3333"
                y="6.03347"
                width="21.3335"
                height="19.167"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="3.33336" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 0.55181 0 0 0 0 0.138096 0 0 0 1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3399_2912"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3399_2912"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_3399_2912"
                x1="21.0009"
                y1="7.54395"
                x2="21.0009"
                y2="23.4509"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF9A38" />
                <stop offset="1" stop-color="#F27120" />
            </linearGradient>
            <clipPath id="clip0_3399_2912">
                <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(12 6.5)"
                />
            </clipPath>
            <clipPath id="clip1_3399_2912">
                <rect
                    width="18"
                    height="16"
                    fill="white"
                    transform="translate(12 7.5)"
                />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
